import React, { useContext, useMemo } from "react";
import i18n from "i18next";
import { ReactReduxContext, useSelector } from "react-redux";
import { isPage } from "../../../../common/utils";
import {
  getSceneDisplayDurationSec,
  formatDurationClock,
} from "../../../../common/scene_duration.es6";

const present = (s) => (s.undoGroup && s.undoGroup.present) || s;

/**
 * Total playback length of the visible scenes, shown in the Scenes header.
 * Uses the visor's per-row duration chain so it matches what learners see.
 */
function TotalDuration() {
  const navItemsIds = useSelector((s) => present(s).navItemsIds);
  const navItemsById = useSelector((s) => present(s).navItemsById);
  const boxesById = useSelector((s) => present(s).boxesById);
  const pluginToolbarsById = useSelector((s) => present(s).pluginToolbarsById);
  const soundList = useSelector((s) => present(s).soundList);

  const totalSec = useMemo(() => {
    const state = { navItemsById, boxesById, pluginToolbarsById, soundList };
    return (navItemsIds || [])
      .filter((id) => id && navItemsById[id] && !navItemsById[id].hidden && isPage(id))
      .reduce((sum, id) => sum + getSceneDisplayDurationSec(id, state), 0);
  }, [navItemsIds, navItemsById, boxesById, pluginToolbarsById, soundList]);

  if (!(totalSec > 0)) return null;
  const clock = formatDurationClock(totalSec);
  return (
    <span className="sectionDuration" title={i18n.t("index_total_duration")}>
      {clock}
    </span>
  );
}

// FileTree is also rendered store-less (unit tests); skip instead of throwing.
export default function ScenesTotalDuration() {
  const ctx = useContext(ReactReduxContext);
  return ctx && ctx.store ? <TotalDuration /> : null;
}
